import { createSlice } from '@reduxjs/toolkit';
const toggleSlice = createSlice({
  name: 'toggle',
  initialState: {
    value: false, // or true, depending on your default
  },
  reducers: {
    toggle(state) {
      state.value = !state.value;
    },
    setTrue(state) {
      state.value = true;
    },
    setFalse(state) {
      state.value = false;
    },
  },
});
export const { toggle, setTrue, setFalse } = toggleSlice.actions;
export default toggleSlice;